// extracted by mini-css-extract-plugin
export default {"coffeeSubscription":"CoffeeSubscription_coffeeSubscription__vBV9s"};